import * as tslib_1 from "tslib";
import { Directive, HostListener, ElementRef, Input, Renderer } from '@angular/core';
import { AbstractControl } from '@angular/forms';
var FormlyAttributes = (function () {
    function FormlyAttributes(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.attributes = ['id', 'name', 'placeholder', 'tabindex', 'step', 'aria-describedby'];
        this.statements = ['change', 'keydown', 'keyup', 'keypress', 'click', 'focus', 'blur'];
    }
    FormlyAttributes.prototype.onFocus = function () {
        this.field.focus = true;
    };
    FormlyAttributes.prototype.onBlur = function () {
        this.field.focus = false;
    };
    FormlyAttributes.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes['field']) {
            var fieldChanges_1 = changes['field'];
            this.attributes
                .filter(function (attr) { return _this.canApplyRender(fieldChanges_1, attr); })
                .map(function (attr) { return _this.renderer.setElementAttribute(_this.elementRef.nativeElement, attr, _this.getPropValue(_this.field, attr)); });
            this.statements
                .filter(function (statement) { return _this.canApplyRender(fieldChanges_1, statement); })
                .map(function (statement) { return _this.renderer.listen(_this.elementRef.nativeElement, statement, _this.getStatementValue(statement)); });
            if ((fieldChanges_1.previousValue || {}).focus !== (fieldChanges_1.currentValue || {}).focus) {
                this.renderer.invokeElementMethod(this.elementRef.nativeElement, this.field.focus ? 'focus' : 'blur', []);
            }
        }
    };
    FormlyAttributes.prototype.getPropValue = function (field, prop) {
        field = field || {};
        if (field.id && prop === 'aria-describedby') {
            return field.id + '-message';
        }
        if (field.templateOptions && field.templateOptions[prop]) {
            return field.templateOptions[prop];
        }
        return field[prop];
    };
    FormlyAttributes.prototype.getStatementValue = function (statement) {
        var _this = this;
        var fn = this.field.templateOptions[statement];
        return function () { return fn(_this.field, _this.formControl); };
    };
    FormlyAttributes.prototype.canApplyRender = function (fieldChange, prop) {
        var currentValue = this.getPropValue(this.field, prop), previousValue = this.getPropValue(fieldChange.previousValue, prop);
        if (previousValue !== currentValue) {
            if (this.statements.indexOf(prop) !== -1) {
                return typeof currentValue === 'function';
            }
            return true;
        }
        return false;
    };
    return FormlyAttributes;
}());
tslib_1.__decorate([
    Input('formlyAttributes'),
    tslib_1.__metadata("design:type", Object)
], FormlyAttributes.prototype, "field", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", AbstractControl)
], FormlyAttributes.prototype, "formControl", void 0);
tslib_1.__decorate([
    HostListener('focus'),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], FormlyAttributes.prototype, "onFocus", null);
tslib_1.__decorate([
    HostListener('blur'),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], FormlyAttributes.prototype, "onBlur", null);
FormlyAttributes = tslib_1.__decorate([
    Directive({
        selector: '[formlyAttributes]',
    }),
    tslib_1.__metadata("design:paramtypes", [Renderer,
        ElementRef])
], FormlyAttributes);
export { FormlyAttributes };
//# sourceMappingURL=formly.attributes.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/src/components/formly.attributes.js
// module id = 322
// module chunks = 3